import { render, staticRenderFns } from "./SuccessfulPayment.vue?vue&type=template&id=6f5604a0&scoped=true"
import script from "./SuccessfulPayment.vue?vue&type=script&lang=js"
export * from "./SuccessfulPayment.vue?vue&type=script&lang=js"
import style0 from "./SuccessfulPayment.vue?vue&type=style&index=0&id=6f5604a0&prod&lang=css"
import style1 from "./SuccessfulPayment.vue?vue&type=style&index=1&id=6f5604a0&prod&scoped=true&lang=css"
import style2 from "./SuccessfulPayment.vue?vue&type=style&index=2&id=6f5604a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5604a0",
  null
  
)

export default component.exports